import Vue from 'vue'
import VueRouter from 'vue-router'

import ItemHub from "@/views/item/Hub";
import ItemMain from "@/views/item/Main";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login/:clsid',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/timetable',
    name: 'TimeTable',
    component: () => import('../views/TimeTable.vue')
  },

  {
    path: '/quiz', component: ItemHub,
    children: [
      {
        path: 'main',
        name: 'Item_Main',
        component: ItemMain,
        beforeEnter: (to, from, next) => {
          let clsid = localStorage.getItem("clsid");
          let default_info = localStorage.getItem("default_info");
          // console.log(default_info);

          if (clsid == null) {
            // next('/not_found')
            window.document.location.href = "http://next.weliveon.net";
          }
          else if (default_info == null) {
            next('/login/' + clsid);
          } else {
            next();
          }

        }

      },
    ]
  },

  {
    path: '/poll/main',
    name: 'Poll_Main',
    component: () => import('../views/item/Main.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");


      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },

  {
    path: '/non/fulllist/:non_type',
    name: 'Non_FullList',
    component: () => import('../views/non/FullList.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/non/paper/:paperid',
    name: 'Non_Paper',
    component: () => import('../views/non/Start.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/non/playground/:paperid',
    name: 'Non_Playground',
    component: () => import('../views/non/Playground.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },

  {
    path: '/qna/fulllist',
    name: 'Qna_Fulllist',
    component: () => import('../views/qna/Fulllist.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/qna/list/:paperid',
    name: 'Qna_List',
    component: () => import('../views/qna/List.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/qna/detail/:qnaid',
    name: 'Qna_Detail',
    component: () => import('../views/qna/Detail.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/qna/write/:paperid/:qnaid?',
    name: 'Qna_Write',
    component: () => import('../views/qna/Write.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },

  {
    path: '/slide/list',
    name: 'Slide_List',
    component: () => import('../views/slide/List.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/slide/playgroud/:itemid',
    name: 'Slide_Playgroud',
    component: () => import('../views/slide/Playground.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/survey/cover',
    name: 'Survey_Cover',
    component: () => import(/* webpackChunkName: "about" */ '../views/survey/Cover.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },
  {
    path: '/survey/playgroud',
    name: 'Survey_Playgroud',
    component: () => import(/* webpackChunkName: "about" */ '../views/survey/Playground.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
      // console.log(default_info);

      if (clsid == null) {
        // next('/not_found')
        window.document.location.href = "http://next.weliveon.net";
      }
      else if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }

  },

  {
    path: '/:shorten',
    name: 'not_found',
    component: () => import('../views/Notfound.vue'),
    beforeEnter: (to, from, next) => {
      let shorten = to.params.shorten;
      next('/login/' + shorten);
    }

  },


  {
    path: '/',
    name: 'ROOT',
    component: () => import('../views/Main.vue'),
    beforeEnter: (to, from, next) => {
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");

      // if (clsid == null) {
      //   next('/not_found')
      // }
      if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }

    }
  }





]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {

  /*
    if (to.fullPath.indexOf("login") == -1 && to.fullPath.indexOf("entry") == -1) {
  
      let clsid = localStorage.getItem("clsid");
      let default_info = localStorage.getItem("default_info");
  
      if (default_info == null) {
        next('/login/' + clsid);
      } else {
        next();
      }
    }
  */
  next()
})

export default router
